// extracted by mini-css-extract-plugin
export default {"MainMenu":"MainMenu_MainMenu__0D3WX","navigation":"MainMenu_navigation__-rXDC","active":"MainMenu_active__U9dfI","show":"MainMenu_show__SCGar"};